<div class="bc-workitem-chat-list">
  <div class="bc-sidenav-title-wrapper">
    <h2 class="bc-sidenav-title" data-automation-id="chat-list-title">
      <svg-icon icon="chat-large"></svg-icon>
      <span class="bc-sidenav-title-label">{{ ( isHybrid ? 'bcWorkitemChatList.dxTitleChats' : 'bcWorkitemChatList.titleChats' ) | translate}}</span>
      <span [attr.data-automation-id]="'bc-chat-counter'"> ({{ getLiveSessionsCount() }})</span>
    </h2>
    <button class="btn btn-add"
            [attr.aria-label]="'bcWorkitemChatList.startRemoteAccessWithPin' | translate"
            *ngIf="isPinviteEnabled"
            (click)="onNewPinviteClicked()"
            [disabled]="isNewPinviteButtonDisabled()"
            [attr.data-automation-id]="'new-pin-invite-btn'">
      <svg-icon icon="plus"></svg-icon>

      <tooltip-action-list [actionItems]="tooltipActionItems"
                           (clickAction)="selectTooltipAction($event)"></tooltip-action-list>
    </button>
  </div>

  <ul class="bc-workitem-titles-list">
    <li *ngIf="isUseAnswerNextEnabled">
      <workitem-answer-next [workItemType]="workItemType"
                            (itemSelected)="selectWorkitem($event)">
      </workitem-answer-next>
    </li>
    <li class="outer-item pin-invite" [@taskItemAnimation]
        [attr.data-workitem-id]="workItem.id"
        [attr.data-automation-id]="'pin-invite-work-item'"
        *ngFor="let workItem of chatPinviteWorkItemList; trackBy: workItemTrackByFn">

      <div class="item theme-grey traversable-list-item"
           [attr.tabindex]="0"
           (click)="selectPinviteItem(workItem)"
           (keydown)="onPinviteWorkItemKeydown(workItem, $event)"
           [ngClass]="{ opened: isOpened(workItem), focus: isFocused(workItem.id) }">
        <div class="item-inner">
          <div class="visitor-avatar">
            <svg-avatar id="invite"></svg-avatar>
          </div>

          <div class="visitor-name">
            <span>{{ 'bcWorkitemChatList.pinInvitePinCode' | translate }}</span>
            <span data-automation-id="pin-code"> {{ workItem.pinCode | appCharacterGrouper }}</span>
          </div>

          <div class="messages">
            <div>{{ workItem.widgetTitle | translate }}</div>
            <div>
              <div *ngIf="workItem.isExpired()"
                   class="expired-message"
                   data-automation-id="pin-expired-message">{{ 'bcWorkitemChatList.pinExpired' | translate }}</div>
              <div *ngIf="!workItem.isExpired()">
                <span>{{ 'bcWorkitemChatList.expiresIn' | translate }} </span>
                <app-countdown-timer [countUntilTime]="workItem.expiringAt"></app-countdown-timer>
              </div>
            </div>
          </div>

          <div class="shortcut">
            <svg-icon icon="enter-key"></svg-icon>
          </div>
        </div>
      </div>
    </li>

    <ng-container *ngFor="let workitem of chatWorkItemList; trackBy: workItemTrackByFn">
      <li class="outer-item" [@taskItemAnimation]
          [attr.data-automation-id]="'bc-chat-work-item-list-item'"
          [attr.data-workitem-id]="workitem.id"
          [attr.data-pinvitation-id]="workitem.PinvitationID"
          *ngIf="workitem.Name || workitem.OperatorID">
        <div class="item traversable-list-item"
             [attr.tabindex]="0"
             (click)="selectWorkitem(workitem)"
             (keydown)="onWorkitemKeydown(workitem, $event)"
             [ngClass]="generateWorkitemClass(workitem)"
             [attr.data-automation-id]="'bc-chat-traversable-item'">
          <div class="item-inner">
            <div class="visitor-avatar">
              <svg-avatar id="{{ workitem.avatarThemeId }}"></svg-avatar>
            </div>

            <span class="remote-control-indicator">
              <svg-icon *ngIf="workitem.hasActiveRemoteControl" icon="remote-access"></svg-icon>
              <svg-icon *ngIf="workitem.hasActiveAssistedBrowsing" icon="assisted-browsing"></svg-icon>
              <svg-icon *ngIf="workitem.hasActiveVideoSession && isVideoFeatureEnabled" icon="camera-filled"></svg-icon>
            </span>

            <workitem-activity-indicator [unansweredMessageCount]="workitem.unansweredMessages"
                                         [showSecondsRemaining]="workitem.showSecondsRemaining"
                                         [secondsRemainingDisplay]="workitem.secondsRemainingDisplay"
                                         [forceDisableRedDots]="workitem.Ended"
                                         [showWrapUpIndicator]="true"
                                         [showElapsedTimer]="true"
                                         [optionalClassName]="'bc-chat-activity'"></workitem-activity-indicator>

            <div class="visitor-name">{{ workitem.Name || '(Customer)' }}</div>

            <div class="folder-wrapper">
              <div class="visitor-folder" [hidden]="workitem.departmentFolder === ''">
                <svg-icon icon="folder"></svg-icon>
                <span class="department-folder">{{ workitem.departmentFolder }}</span>
              </div>
            </div>

            <div class="messages">
              <div *ngFor="let message of workitem.messages | slice: (workitem.Ended || '') && -1">
                <span [ngClass]="generateLastMessagesClass(message)"
                      [attr.data-automation-id]="'WIDGET_MESSAGES'"
                      [innerHTML]="message.shortText | appOperatorChatMessageFormat"></span>
              </div>
              <div class="chat-has-ended-text" *ngIf="workitem.Ended">{{ 'bcWorkItemList.chatHasEnded' | translate }}</div>
              <div class="shortcut">
                <svg-icon icon="enter-key"></svg-icon>
              </div>
            </div>
          </div>
        </div>

        <app-work-item-interaction *ngIf="isWorkItemAcceptable(workitem)"
                                   (accept)="acceptButtonClicked(workitem, $event)">
        </app-work-item-interaction>
      </li>
      <li *ngIf="isSkeletonLoadingOn && !workitem.Name" class="outer-item">
        <app-skeleton-loader class="skeleton-item" appearance="circle" [mainItemCount]="2" [subItemCount]="2"></app-skeleton-loader>
      </li>
    </ng-container>
  </ul>
</div>
